var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// aspect-schemas/ListAspect.ts
import { Entity } from "@adornis/baseql/decorators.js";
import { html, nothing } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { StringAspect, StringAspectConfig } from "./StringAspect.js";
var ListAspect = class extends StringAspect {
  constructor(doc) {
    super(doc);
  }
};
ListAspect._class = "ListAspect";
ListAspect = __decorateClass([
  Entity()
], ListAspect);
var ListAspectSchema = (values, placeholder, translateValues, advancedModes) => ({
  ...StringAspectConfig("containsExactOR"),
  aspectConstructor: ListAspect,
  renderEditor: ({ aspectValue, translation }) => {
    if (!["containsExactOR", "containsAND", "containsNONE"].includes(aspectValue.mode)) {
      aspectValue.mode = "containsExactOR";
    }
    const keys = !Array.isArray(values) ? Object.values(values) : values;
    if (aspectValue.value) {
      const trimmedValues = aspectValue.value.split(",").map((v) => v.trim());
      const fixed = trimmedValues.filter((v) => keys.includes(v)).join(",");
      if (aspectValue.value !== fixed) {
        aspectValue.value = fixed;
      }
    }
    return html`
      <x-flex horizontal crossaxis-center space="sm">
        ${advancedModes ? html`
              <x-dropdown-selection
                ?flex=${aspectValue.mode === "empty"}
                .selectables=${["containsExactOR", "containsAND", "containsNONE"]}
                .renderString=${(s) => s ? translation.translate("class", `ListAspect${s.toUpperCase()}Aspect`) : ""}
                .value=${aspectValue.mode}
                @value-picked=${(e) => aspectValue.mode = e.detail.value}
              >
              </x-dropdown-selection>
            ` : nothing}
        <x-dropdown-multiselection
          flex
          clearable
          placeholder=${ifDefined(placeholder)}
          placeholder-mode="hide"
          .renderString=${(s) => translateValues ? translateValues({ value: s, translation }) : s}
          .search=${(search) => {
      const arrayValues = keys.map((v) => v.toString());
      const mappedValues = arrayValues.map((value) => ({
        value,
        trans: translateValues ? translateValues({ value, translation }) : value
      }));
      if (!search)
        return arrayValues;
      return mappedValues.filter((v) => v.trans.toLocaleLowerCase().includes(search.toLocaleLowerCase())).map((m) => m.value);
    }}
          @value-picked=${(e) => {
      aspectValue.value = e.detail.value?.length ? e.detail.value.join(",") : null;
    }}
          .value=${aspectValue.value?.split(",")}
        ></x-dropdown-multiselection>
      </x-flex>
    `;
  },
  renderPreview: ({ aspectValue, translation }) => aspectValue.value?.length ? html`${translateValues ? aspectValue.value.split(",").map((v) => translateValues({ value: v, translation })).join(", ") : aspectValue.value}` : null
});
export {
  ListAspect,
  ListAspectSchema
};
